
    document.addEventListener('DOMContentLoaded', function () {
      const toggleBtn = document.querySelector('.toggle-btn');
      let isExpanded = false;
    
      if (toggleBtn) {
        const hiddenItems = document.querySelectorAll('.coupon-item.hidden');
    
        toggleBtn.addEventListener('click', function () {
          isExpanded = !isExpanded;
          hiddenItems.forEach(item => item.classList.toggle('hidden'));
          this.textContent = isExpanded
            ? 'Show Less Offers'
            : 'Show More Offers (3)';
        });
      }
    
      document.querySelectorAll('.copy-btn').forEach(btn => {
        btn.addEventListener('click', function () {
          const code = this.dataset.code;
          const tempInput = document.createElement('textarea');
          tempInput.value = code;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);
    
          this.classList.add('copied');
          this.textContent = 'Copied!';
    
          setTimeout(() => {
            if (toggleBtn && isExpanded) {
              toggleBtn.click();
              isExpanded = false;
            }
    
            setTimeout(() => {
              this.classList.remove('copied');
              this.textContent = 'Copy';
            }, 500);
          }, 1000);
        });
      });
    });